import Colors from 'enums/Colors';
import styled from 'styled-components';

const StyledAlfabetizacaoNewDetail = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        padding-top: 84px;

        @media screen and (max-width: 900px) {
            padding-top: 0;
        }
    `,

    ButtonYellow: styled.button`
        min-width: 189px;
        width: fit-content;
        height: 46px;
        border-radius: 4px;
        gap: 10px;
        padding-top: 10px;
        padding-right: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        border: none;
        background-color: ${Colors.Yellow};
        color: ${Colors.Blue};

        @media screen and (max-width: 500px) {
            width: 250px;
        }
    `,
    ButtonBlue: styled.button`
        min-width: 189px;
        width: fit-content;
        height: 46px;
        border-radius: 4px;
        gap: 10px;
        padding-top: 10px;
        padding-right: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        border: none;
        background-color: ${Colors.Blue};
        color: ${Colors.White};
    `,
    ButtonOutline: styled.button`
        display: flex;
        align-items: center;
        min-width: 189px;
        width: fit-content;
        height: 46px;
        border-radius: 4px;
        gap: 10px;
        padding-top: 10px;
        padding-right: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        border: none;
        background-color: transparent;
        border: 1px solid ${Colors.Blue};
        color: ${Colors.Blue};
    `,

    Bottom: styled.div`
        border: 1px solid red;
        background-color: #00aef1; /* azul */
        clip-path: ellipse(100% 80% at 40% 0%);
        height: 300px; /* ajuste conforme necessário */
        position: relative;
        overflow: hidden;
        z-index: 10;
    `,
};

export default StyledAlfabetizacaoNewDetail;
